<template>
  <div class="homepage-5">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection/>
      <FeatureSection />
      <DiscoverSection />
      <ServiceSection />
      <WorkSection />
      <ScreenshotSection />
      <ReviewSection />
      <PricingSection />
      <TeamSection />
      <DownloadSection />
      <NewsletterSection />
      <ContactSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/heroFive'
import FeatureSection from '../components/FeatureSection/featureFive'
import DiscoverSection from '../components/DiscoverSection/discoverFive'
import ServiceSection from '../components/ServiceSection/serviceFive'
import WorkSection from '../components/WorkSection/work'
import ScreenshotSection from '../components/ScreenshotSection/screenshotTwo'
import ReviewSection from '../components/ReviewSection/reviewTwo'
import PricingSection from '../components/PricingSection/pricingThree'
import TeamSection from '../components/TeamSection/team'
import DownloadSection from '../components/DownloadSection/download'
import NewsletterSection from '../components/NewsletterSection/newsletter'
import ContactSection from '../components/ContactSection/contactGeneral'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'ThemeFive',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    FeatureSection,
    DiscoverSection,
    ServiceSection,
    WorkSection,
    ScreenshotSection,
    ReviewSection,
    PricingSection,
    TeamSection,
    DownloadSection,
    NewsletterSection,
    ContactSection,
    FooterSection
  }
}
</script>

<style>

</style>